import {SET_LANGUAGE_SELECTED} from '../storeConstants';

export const setLanguageSelected = (lang) => {
  return {
    type: SET_LANGUAGE_SELECTED,
    val: lang
  };
};